import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine class names cleanly, with Tailwind conflict resolution.
 * Use everywhere instead of template strings or inline ternaries.
 * Example:
 *   cn("px-2 py-1", isActive && "bg-brand-600", className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
